import { useState } from "react";
import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase/config";

export const useInstances = () => {
  const [error, setError] = useState(null);
  const [isPending, setIsPending] = useState(false);

  const extractInstanceAndWorkspace = (url) => {
    try {
      // Prepend protocol if missing
      if (!/^https?:\/\//i.test(url)) {
        url = `https://${url}`;
      }
      const parsedUrl = new URL(url);

      // Extract subdomain as instance name
      const hostname = parsedUrl.hostname;
      const instance = hostname.replace(/^www\./, "").split(".")[0];

      // Extract workspace if path starts with /w/
      const pathParts = parsedUrl.pathname.split("/");
      let workspace = null;
      if (pathParts[1] === "w" && pathParts[2]) {
        workspace = pathParts[2];
      }

      return { instance, workspace };
    } catch (error) {
      return { instance: null, workspace: null };
    }
  };

  const getAccessForInstance = async (instance, body, apiKey, secretKey) => {
    setError(null);
    setIsPending(true);

    const instanceName = extractInstanceAndWorkspace(instance); // extract only subdomain

    if (!instanceName) return;

    try {
      // signup user
      const res = await httpsCallable(
        functions,
        "getAccessForInstance"
      )({
        instance: instanceName.instance,
        workspace: instanceName.workspace,
        body: body,
        apiKey,
        secretKey,
      });
  
      if (!res) {
        throw new Error("could not complete stations");
      }

      setIsPending(false);
      setError(null);
      return res;
    } catch (err) {
      console.log(err.message);
      setError(err.message);
      setIsPending(false);
    }
  };

  return { error, isPending, getAccessForInstance };
};
